import makeStyles from '@mui/styles/makeStyles';

const setupHomePageStyles = makeStyles((theme) => ({
    icon: {
        fontSize: '22px',
        minWidth: '22px',
        maxWidth: '22px',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        borderRadius: '50%',
        padding: '7px',
        marginBottom: theme.spacing(1),
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    categoryTitle: {
        fontWeight: 'bold',
        paddingBottom: theme.spacing(2),
        letterSpacing: theme.spacing(1)
    },
    wrapContent: {
        width: 'auto',
        padding: theme.spacing(2),
        minWidth: '200px',
        maxWidth: '250px',
        [theme.breakpoints.up('lg')]: {
            flexGrow: 1,
            minWidth: 'unset'
        }
    },
    linkStyle: {
        textDecoration: 'unset',
        paddingBottom: theme.spacing(1),
        lineHeight: '1.5',
        fontWeight: 600,
        color: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.dark
        }
    },
    noPermission: {
        textDecoration: 'unset',
        paddingBottom: theme.spacing(1),
        lineHeight: '1.5',
        fontWeight: 600,
        color: theme.palette.grey['500'],
        pointerEvents: 'none'
    },
    activeRoute: {
        textDecoration: 'underline'
    },
    notDeveloped: {
        textDecoration: 'line-through',
        pointerEvents: 'none',
        color: theme.palette.grey['500'],
        '&:hover': {
            textDecoration: 'line-through',
            color: theme.palette.grey['400'],
            cursor: 'auto'
        }
    },
    container: {
        padding: theme.spacing(0, 2.3)
    }
}));

export default setupHomePageStyles;
